import { useQuery } from '@apollo/client'
import { getPageList as getPageListGql }
   from 'src/graphql/queries/getPageList.gql'

const usePageList = (variables, options) => {
   const { data, error, fetchMore, loading, networkStatus, refetch } = useQuery(getPageListGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
      ...options
   })

   return {
      pageList: data
         ? data.pageList
         : { items: [], listInfo: {} },
      error,
      fetchMore,
      loading,
      networkStatus,
      refetch
   }
}

export default usePageList
